import { select, Store } from "@ngrx/store"
import { Subscription } from "rxjs"
import { filter } from "rxjs/operators"
import { virtualCardsResModel } from "src/app/home/models/favoriteResponse.model"
import { HomeActions } from "src/app/home/ngrx/home-action-types"
import { isSelectCardBalance, selectCardBalance } from "src/app/home/ngrx/home-selectors"

export class CardBalanceState{
    constructor(protected store: Store){}

    subscriptions = new Subscription();

    getCardBalanceIfNotExist = (alias:string) => {
        this.subscriptions.add(
            this.store.pipe(
                select(isSelectCardBalance(alias)),
                filter(state => state == false)
            ).subscribe(
                () => this.store.dispatch(HomeActions.upsertCardBalance({alias: alias}))
            )
        );
    }

    loadCardBalance$ = (alias:string) => {
        return this.store.pipe(
            select(
                selectCardBalance(alias)
            ),
        );
    }

    unsubscribeFromStore = () => {
        this.subscriptions.unsubscribe();
    }
}